// TODO: explaining header. Functions for comparing, validation and generating data structures
import { config } from './config.js';
import { isBefore, isAfter } from 'date-fns';

// Compare form values to the account's allowed preferences (config.js!). 
// Return valid settings JSON
export function findValidPrefs(state) {
  // get all possible values; all inactive at first ...
  var fields_of_account = [ ...config.portals[state.account_id].fields];
  
  //console.log("++++ selectedCities: ", state.selectedCities);
  //console.log("++++ FULL STATE OBJECT: ", state);

  ////////////////////////////////////////////////////////////////////
  // update fields to send. loop through portals possible preferences:
  for (let i = 0; i < fields_of_account.length; i++) {

    // activate all preferences in JSON now, if found
    for (let key in state) {
      if (fields_of_account[i].key === 'Preferences.'+key) {
        // 20200813, SB: form not updated!?
        if (state[key] && !state.SUPPRESSED) {
          fields_of_account[i].value = 'active';
        } else { 
          fields_of_account[i].value = 'inactive'; 
        }

        // 20200813, SB: aaaah fuck it! Don't you deactivate suppressions here, but activate!
        if (state.SUPPRESSED && key === 'SUPPRESSED') { 
          fields_of_account[i].value = 'active'; 
        }
      } // else { console.log("XXXXXX FIXME: NOT FOUND:>", key, "<   => ", state[key]); } 
    }

  } // END: for fields_of_account


  // TODO: this could be merged to the loop above, now!
  // check and handle available dailyMails; compare to multiselect
  for (let i = 0; i < state.portal.dailyMails.keys.length; i++) {
    //console.log("dailyMail TO CHECK: ", state.portal.dailyMails.keys[i]);
    //console.log("SELECTED CITIES: ", state.selectedCities);

    // inactive as default, overwrite to active if found
    let status = 'inactive';

    // if checkbox checked, and not SUPPRESSED, change status to 'active'
    if (state.cbDailyMail && !state.SUPPRESSED) {
      // iterate through chosen cities
      for (let j in state.selectedCities) {
        let currKey = state.selectedCities[j].key;
        //console.log("##### SELECTED CITY: ", currKey);
        //console.log("#### FIELD TO COMPARE",fields_of_account[i].key);

        // select might not return an array but a HASH, so get those key:
        if (currKey === undefined) {
          currKey = state.selectedCities.key;
          console.log("-----  SELECT IS NOT AN ARRAY!", j, currKey);
        }

        // activate city NL if in selectedCities
        if (fields_of_account[i].key === 'Preferences.'+currKey) {
          //console.log("HIT CITY ACTIVATE: ", currKey);
          status = 'active';
        }
      }
    }

    // finally set status for this dailyMail
    fields_of_account[i].value = status;
    console.log("dailyMail WAS CHECKED: ", state.portal.dailyMails.keys[i], " => ", status);
  }

  // 20210429, SB: additive on subscribe mode! Don't send inactive (see MARKE_SUPPRESSED)
  if (state.mode === "subscribe") {
    fields_of_account = fields_of_account.filter( el => (el.value !== 'inactive') );
    fields_of_account.push( { key: "Preferences.SUPPRESSED", value: "inactive" } );
  }

  // MARKE_BUG: TODO: not needed anymore, is it!?
  const fields_return_copy = JSON.parse(JSON.stringify(fields_of_account))  
  return fields_return_copy;
}


// read portals account settings and return dynamic field of state vars
export function getDynamicStates(account_id, portal, subscriber) {
    const fields_raw = JSON.parse(JSON.stringify(portal.fields));
    let identifier = 'id';

    // 20201006, SB: Links in NL-Footer passes Email now!
    if (subscriber && subscriber.includes('@')) {  identifier = 'email' };

    // check if now between start and end
    const isActive = (isBefore(new Date(),new Date(portal.aktion.endDate)) && isAfter(new Date(),new Date(portal.aktion.startDate)));

    // basic app states first
    let allStates = {
      year: new Date().getFullYear(),
      presentDay: new Date(), // 'today' for comparing in between start and end dates
      aktionActive: isActive,
      fetchInProgress: true,  // AJAX calling, show Barloader!
      mode: (subscriber ? 'setup' : 'subscribe'), // use setup mode if subscriber ID passed
      SUPPRESSED: false,      // "opt-out" from all newsletters of this account; checkbox value!
      cbDailyMail: false,     // checkbox toggle status
      portal: portal,         // keeps portal's configs
      fields: portal.fields,  // full set of inactive preferences. Form values set active.
      fields_raw: fields_raw, // full set of inactive preferences. Form values set active.
      account_id: account_id, // rule account from config
      subscriber: subscriber, // subscriber's ID 
      identifier: identifier, // what to use as identifier: 'email' or 'id'
      ddChooseCity: 0,        // daily mail dropdown value
      selectedCities: [],     // multiselect values 
      showDailySelect: false, // toggle visibility of dropdown
      disableSubmit: true,    // disables the submit-button!
      message: { type: "success", txt: 0 },
      checkedNewsletters: new Map(), // array of all checkboxes
    }

    // add dynamic STATES for topicMails
    for (var i in portal.topicMails) {
      allStates[`${portal.topicMails[i].key}`] = false;
      //console.log("dynamic_topicMails: ", i,": ", portal.topicMails[i].key);
    }

    // add dynamic STATES for specialMails
    for (var j in portal.specialMails) {
      allStates[`${portal.specialMails[j].key}`] = false;
      //console.log("dynamic_specialMails: ", portal.specialMails[j].key);
    }
    //console.log("allStates: ", allStates);  

    return allStates;
}